var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83199 7.02442C7.88524 7.0775 7.9275 7.14058 7.95633 7.21003C7.98516 7.27949 8 7.35395 8 7.42916C8 7.50436 7.98516 7.57882 7.95633 7.64828C7.9275 7.71773 7.88524 7.78081 7.83199 7.8339C7.72419 7.94033 7.57883 8 7.42737 8C7.27591 8 7.13054 7.94033 7.02275 7.8339L4 4.81025L0.977251 7.8339C0.869456 7.94033 0.724091 8 0.572631 8C0.421171 8 0.275806 7.94033 0.168011 7.8339C0.114757 7.78081 0.0725033 7.71773 0.0436722 7.64828C0.0148412 7.57882 0 7.50436 0 7.42916C0 7.35395 0.0148412 7.27949 0.0436722 7.21003C0.0725033 7.14058 0.114757 7.0775 0.168011 7.02442L3.19076 4.00077L0.168011 0.977128C0.0606989 0.869785 0.000411661 0.724195 0.000411661 0.572389C0.000411661 0.497221 0.0152126 0.42279 0.0439693 0.353345C0.072726 0.2839 0.114875 0.2208 0.168011 0.167649C0.221146 0.114498 0.284227 0.0723358 0.353652 0.0435705C0.423077 0.0148053 0.497486 0 0.572631 0C0.724393 0 0.869939 0.0603051 0.977251 0.167649L4 3.19129L7.02275 0.167649C7.13006 0.0603051 7.27561 0 7.42737 0C7.57913 0 7.72468 0.0603051 7.83199 0.167649C7.9393 0.274992 7.99959 0.420582 7.99959 0.572389C7.99959 0.724195 7.9393 0.869785 7.83199 0.977128L4.80924 4.00077L7.83199 7.02442Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.2fe691db430b08e84de06d901a10e8a3.svg";
export { ForwardRef as ReactComponent };